const UPSELL_RECOMMENDATION_TYPES = {
  SHOES: 'SHOES',
  SOCKS: 'SOCKS',
  APPAREL: 'APPAREL',
  GIFT_CARDS: 'GIFT_CARDS',
  UNISEX: 'UNISEX',
};

const UNISIZE = 1;

export { UPSELL_RECOMMENDATION_TYPES, UNISIZE };
